/**
 * SAF-20237: Multi-role switcher rendered in NavigationBar.otherButtons.
 * Kept separate from menuItems so role switch does not appear as a top-level nav tab.
 */
import React from 'react';import styled from 'styled-components';
import NavigationMenuItem from 'apollo-react/components/NavigationBar/NavigationMenuItem';
import { NAVIGATION_BAR_CONFIG } from './navigationBarConfig';

const MenuContainer = styled.div`
    display: flex;
    align-items: center;
    height: 55px;
    margin-right: 8px;
`;

const SwitchRoleMenu = ({ availableRoles, currentActiveRole, onRoleSelect }) => {
    if (!availableRoles || availableRoles.length <= 1) {
        return null;
    }

    const menuItems = availableRoles.map((role) => ({
        text: role.roleDisplayVal,
        active: role.roleVal === currentActiveRole,
    }));

    const handleClick = (item) => {
        const selectedRole = availableRoles.find((role) => role.roleDisplayVal === item.text);
        if (selectedRole) {
            onRoleSelect(selectedRole.roleVal);
        }
    };

    return (
        <MenuContainer>
            <NavigationMenuItem
                variant={NAVIGATION_BAR_CONFIG.variant}
                text="Switch Role"
                menuItems={menuItems}
                onClick={handleClick}
            />
        </MenuContainer>
    );
};

export default SwitchRoleMenu;
